export default {
  name: "",
  loggedIn: false
};
